
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/search",
      function () {
        return require("private-next-pages/auto-parts/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/search"])
      });
    }
  